import { render, staticRenderFns } from "./ReceptionDetailEditorCommentTabSelector.vue?vue&type=template&id=05d0bf9d&scoped=true&"
import script from "./ReceptionDetailEditorCommentTabSelector.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailEditorCommentTabSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailEditorCommentTabSelector.vue?vue&type=style&index=0&id=05d0bf9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0bf9d",
  null
  
)

export default component.exports